import { Component } from 'react';
import { connect, Provider } from 'react-redux';

import { MarkerF } from '@react-google-maps/api';
import _ from 'lodash';
import { Responsive, Segment } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import createStore from '../store';
import fetchInformation from '../store/information/action/fetchInformation';
import available from '../assets/location_available.svg';
import inUse from '../assets/location_in_use.svg';
import inactive from '../assets/location_inactive.svg';
import Images from './sidebar/Images';
import Title from './sidebar/Title';
import GeneralInfo from './sidebar/GeneralInfo';
import Stations from './sidebar/Stations';
import MobileApplicationLinks from './sidebar/MobileApplictionLinks';
import Footer from './sidebar/Footer';
import Close from '../assets/close';

const icon = [inactive, available, inUse];

const styles = {
  container: {
    position: 'absolute',
    width: '0',
    backgroundColor: '#edeff1',
    boxShadow: '2px 0 0 0 rgba(0, 0, 0, 0.12)',
  },
  info: {
    boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.3)',
  },
  stationContainer: {
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '15px',
  },
  mobileApplicationText: {
    fontSize: '14px',
    fontWeight: 'normal',
    paddingLeft: '15px',
    paddingRight: '50px',
    paddingBottom: '64px',
  },
  closeBtn: {
    position: 'absolute',
    top: '0px',
    right: '12px',
  },
};
Object.freeze(styles);

class Markers extends Component {
  constructor() {
    super();
    const store = createStore();
    this.state = {
      store,
    };
  }

  callForGettingInformation(id) {
    const { store } = this.state;
    if (id !== null) {
      store.dispatch(fetchInformation(id));
    }
  }

  render() {
    const {
      map,
      stations,
      checkIFrame,
      t,
      googlePlayStoreLink,
      appleAppStoreLink,
      brandColorPreview,
    } = this.props;

    // eslint-disable-next-line react/destructuring-assignment
    const hostColor = (brandColorPreview !== false) ? brandColorPreview : this.props.hostColor;

    const { store } = this.state;

    if (_.isNil(stations)) {
      return null;
    }

    const pageHeight = window.screen.height;

    const statuseTranslations = {
      available: t('EVSEStatuses.available'),
      occupied: t('EVSEStatuses.occupied'),
      connected: t('EVSEStatuses.connected'),
      charging: t('EVSEStatuses.charging'),
      reserved: t('EVSEStatuses.reserved'),
      unavailable: t('EVSEStatuses.unavailable'),
    };

    const onMarkerClick = (centerPoint) => {
      if (map) {
        map.panTo(centerPoint);
      }

      const evseSection = document.querySelectorAll('[id^=evseSection]');
      for (let i = 0; i < evseSection.length; i += 1) {
        evseSection[i].style.boxShadow = 'none';
        evseSection[i].style.boxSizing = 'none';
        evseSection[i].style.borderRadius = '0';
      }
    };

    const openNav = (stationId, mode) => {
      this.callForGettingInformation(stationId);

      let width = '375px';
      if (mode === 'Desktop') {
        const sidebar = document.getElementById('stationSidebar');
        if (sidebar) {
          sidebar.style.left = '0';
          sidebar.style.transition = 'left 0.3s ease-out';
          sidebar.style.width = width;
        }
      } else {
        width = '100%';
        const sidebar = document.getElementById('stationSidebar');
        if (sidebar) {
          sidebar.style.bottom = '0';
          sidebar.style.transition = 'bottom 0.3s ease-out';
          sidebar.style.width = width;
        }
      }

      const footer = document.getElementById('footer');
      if (footer) {
        footer.style.bottom = '-56px';
        footer.style.transition = 'bottom 0s';
      }

      const navbar = document.getElementById('navbar');
      if (navbar) {
        if (mode !== 'Desktop') {
          navbar.style.display = 'none';
        } else {
          navbar.style.display = 'block';
        }
      }
    };

    const closeNav = (mode) => {
      const sidebar = document.getElementById('stationSidebar');
      if (sidebar) {
        if (mode === 'Desktop') {
          sidebar.style.left = '-375px';
          sidebar.style.transition = 'left 0.3s ease-in';
        } else {
          sidebar.style.top = null;
          sidebar.style.position = 'fixed';
          sidebar.style.bottom = `-${pageHeight}px`;
          sidebar.style.transition = 'bottom 0.3s ease-in';
        }
      }

      const navbar = document.getElementById('navbar');
      if (navbar) navbar.style.display = 'block';

      const footer = document.getElementById('footer');
      if (footer) footer.style.bottom = '-56px';
    };

    let marginFromTop = '64px';
    if (checkIFrame === true) {
      marginFromTop = '0';
    }

    const markers = stations.map((station) => (
      <MarkerF
        key={station.id}
        position={{ lat: station.latitude, lng: station.longitude }}
        icon={{
          url: icon[station.status],
          scaledSize: new window.google.maps.Size(30, 30),
        }}
        onClick={() => {
          onMarkerClick({
            lat: station.latitude,
            lng: station.longitude,
          });

          // Determine mode dynamically based on window width
          const mode = window.innerWidth >= 600 ? 'Desktop' : 'Mobile';
          openNav(station.id, mode);
        }}
      />
    ));

    return (
      <div>
        {/* Render markers directly without extra wrappers */}
        {markers}

        {/* The Sidebar UI remains wrapped in Responsive as it is standard HTML/DOM */}
        <Responsive
          as={Segment}
          minWidth={600}
          id="stationSidebar"
          style={{
            ...styles.container,
            top: marginFromTop,
            left: '-375px',
            bottom: '0',
            overflow: 'auto',
          }}
        >
          <div style={{ position: 'relative', height: '100%' }}>
            <Provider store={store}>
              <Images />
              <div
                style={{
                  ...styles.info,
                  paddingTop: '14px',
                  backgroundColor: '#fafafa',
                }}
              >
                <div style={{ position: 'relative' }}>
                  <Title />
                  <CloseBtn
                    style={styles.closeBtn}
                    onClick={() => { closeNav('Desktop'); }}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0"
                  >
                    <Close />
                  </CloseBtn>
                  <GeneralInfo />
                </div>
              </div>
              <div style={{ ...styles.stationContainer }}>
                <Stations
                  title={t('stationSidebar.evseSelectionTitle')}
                  brandColor={hostColor}
                  otpDisabledBtn={t('stationSidebar.RegisterToChargeHere')}
                  otpActiveBtn={t('stationSidebar.start')}
                  statusText={statuseTranslations}
                />
              </div>
              <div style={{ ...styles.mobileApplicationText }}>
                <MobileApplicationLinks
                  title={t('stationSidebar.mobileAppsDesc')}
                  googlePlay={googlePlayStoreLink}
                  appStore={appleAppStoreLink}
                />
              </div>
              <div>
                <Footer
                  title={t('stationSidebar.start')}
                  width="375px"
                />
              </div>
            </Provider>
          </div>
        </Responsive>

        <Responsive
          as={Segment}
          maxWidth={599}
          id="stationSidebar"
          style={{
            ...styles.container,
            height: '100%',
            bottom: `-${pageHeight}px`,
            overflow: 'auto',
          }}
        >
          <div style={{ position: 'relative', height: '100%' }}>
            <Provider store={store}>
              <Images />
              <div
                style={{
                  ...styles.info,
                  paddingTop: '14px',
                  backgroundColor: '#fafafa',
                }}
              >
                <div style={{ position: 'relative' }}>
                  <Title />
                  <CloseBtn
                    style={styles.closeBtn}
                    onClick={() => { closeNav('Mobile'); }}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0"
                  >
                    <Close />
                  </CloseBtn>
                  <GeneralInfo />
                </div>
              </div>
              <div style={{ ...styles.stationContainer }}>
                <Stations
                  title={t('stationSidebar.evseSelectionTitle')}
                  brandColor={hostColor}
                  otpDisabledBtn={t('stationSidebar.RegisterToChargeHere')}
                  otpActiveBtn={t('stationSidebar.start')}
                  statusText={statuseTranslations}
                />
              </div>
              <div>
                <div style={{ ...styles.mobileApplicationText }}>
                  <MobileApplicationLinks
                    title={t('stationSidebar.mobileAppsDesc')}
                    googlePlay={googlePlayStoreLink}
                    appStore={appleAppStoreLink}
                  />
                </div>
              </div>
            </Provider>
            <Footer
              title={t('stationSidebar.start')}
              width="100%"
            />
          </div>
        </Responsive>
      </div>
    );
  }
}

const CloseBtn = styled.div`
  :focus {
    outline: 0;
  }
`;

const mapStateToProps = (state) => ({
  stations: state.status.data,
  googlePlayStoreLink: state.customization.host.googlePlayStoreLink,
  appleAppStoreLink: state.customization.host.appleAppStoreLink,
  hostColor: state.customization.host.brandColor,
});

export default withTranslation()(connect(mapStateToProps)(Markers));
